var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5470_11606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13.0002C5 12.4697 5.21074 11.961 5.58585 11.5859C5.96096 11.2107 6.46973 11 7.00022 11H17.0013C17.5318 11 18.0406 11.2107 18.4157 11.5859C18.7908 11.961 19.0015 12.4697 19.0015 13.0002V19.0009C19.0015 19.5314 18.7908 20.0401 18.4157 20.4152C18.0406 20.7903 17.5318 21.0011 17.0013 21.0011H7.00022C6.46973 21.0011 5.96096 20.7903 5.58585 20.4152C5.21074 20.0401 5 19.5314 5 19.0009V13.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.0001C11 16.2654 11.1054 16.5197 11.2929 16.7073C11.4805 16.8948 11.7349 17.0002 12.0001 17.0002C12.2654 17.0002 12.5197 16.8948 12.7073 16.7073C12.8948 16.5197 13.0002 16.2654 13.0002 16.0001C13.0002 15.7349 12.8948 15.4805 12.7073 15.2929C12.5197 15.1054 12.2654 15 12.0001 15C11.7349 15 11.4805 15.1054 11.2929 15.2929C11.1054 15.4805 11 15.7349 11 16.0001Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0009V7.00043C8 5.93945 8.42147 4.92193 9.1717 4.1717C9.92193 3.42147 10.9395 3 12.0004 3C13.0614 3 14.0789 3.42147 14.8292 4.1717C15.5794 4.92193 16.0009 5.93945 16.0009 7.00043V11.0009",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5470_11606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/ChangePassword.a8bf4bc6e64c46abed1f0b7fc8e5b334.svg";
export { ForwardRef as ReactComponent };